var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExpandAll = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "play-button")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Summary/CSA_Drilldown/Expand_Button",
    transform: "translate(-830.000000, -11.000000)",
    fill: "#335498",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play-button",
    transform: "translate(838.433358, 19.538476) rotate(-30.000000) translate(-838.433358, -19.538476) translate(825.933358, 7.038476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9366647,8.25065219 C17.5898757,4.18583531 12.392038,2.79304214 8.32759391,5.14029188 C4.26282505,7.48678381 2.86999421,12.6844664 5.21721622,16.7491209 C7.56368043,20.8139378 12.7613558,22.2069475 16.825854,19.8599143 C20.890677,17.5126104 22.2841574,12.3151984 19.9366647,8.25065219 Z M15.9762012,18.3874432 C12.7248733,20.2652863 8.56635409,19.1509868 6.68907446,15.8989709 C4.81136181,12.6476046 5.92602703,8.48909042 9.17746322,6.61216751 C12.4290077,4.73443268 16.5873103,5.84862391 18.4646982,9.10053154 C20.3421402,12.352385 19.2277998,16.5100332 15.9762012,18.3874432 Z M15.6363293,12.1545436 L11.1862206,9.55911239 C10.780691,9.32235216 10.4535933,9.51164126 10.4558667,9.98072313 L10.4786548,15.1323961 C10.4807116,15.6013697 10.8118148,15.7922827 11.2185353,15.5573628 L15.6345971,13.0077248 C16.0408846,12.773238 16.0417506,12.3913038 15.6363293,12.1545436 Z",
    id: "Shape",
    transform: "translate(12.576952, 12.500000) rotate(120.000000) translate(-12.576952, -12.500000) "
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExpandAll, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Expand All.b08e4674.svg";
export { ForwardRef as ReactComponent };